<template>
  <div class="vpassword">
    <label v-if="label">{{ $tr(label) }}</label>
    <vpassinput
      v-model="inner_val"
      :error="error"
      :name="name"
      :open="open"
      :placeholder="placeholder"
    ></vpassinput>
  </div>
</template>

<script>
  /*
  @ complex component
  @ props: value(any), error(bool), label(string mask), name(any), open(bool)
  @ emit: input
*/
  export default {
    name: 'vpassword',
    props: ['value', 'error', 'label', 'name', 'open', 'placeholder'], // open - защита от сохранение браузером введеного значения
    computed: {
      inner_val: {
        set(v) {
          this.$emit('input', v);
        },
        get() {
          return this.value;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '../../assets/styles/vars.scss';
  .vpassword {
    margin-bottom: 17px;
    & label {
      display: block;
      margin-bottom: 7px;
      font-size: 14px;
      color: $color-text-light-grey;
    }
  }
</style>
